window.addEventListener('DOMContentLoaded', () => {
  const menu     = document.querySelector('.faq-menu ul');
  const links    = Array.from(document.querySelectorAll('.faq-menu .faq-link'));
  const categories = Array.from(document.querySelectorAll('.faq-category'));
  const questions  = Array.from(document.querySelectorAll('.faq-question'));

  // Scroll sur le contenu au clic
  links.forEach((link, i) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const target = categories[i];
      // scroll du contenu
      window.scrollTo({ top: target.offsetTop - 20, behavior: 'smooth' });
      // scroll du menu pour centrer l'item
      link.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    });
  });

  // Toggle des réponses
  questions.forEach(btn => {
    btn.addEventListener('click', () => {
      const answer = btn.parentElement.querySelector('.faq-answer');
      answer.classList.toggle('open');
      btn.classList.toggle('active');
    });
  });

  // Sur veille de scroll : mise à jour de l'item actif + scroll du menu
  let lastActive = null;
  const onScroll = () => {
    const scrollPos = window.scrollY + 50;
    let activeIdx = 0;
    categories.forEach((cat, i) => {
      if (scrollPos >= cat.offsetTop) activeIdx = i;
    });

    if (activeIdx !== lastActive) {
      links.forEach((link, i) => {
        link.classList.toggle('active', i === activeIdx);
      });
      // scroll du menu pour faire apparaître/centrer l'item
      links[activeIdx].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      lastActive = activeIdx;
    }
  };

  window.addEventListener('scroll', onScroll);
  onScroll();
});
